export interface GetUserNowStatusRequest {
  id: string
}

export function GetUserNowStatusRequestToJSON(
  value: GetUserNowStatusRequest
): any {
  return {
    id: value.id !== '' ? value.id : undefined
  }
}
